/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:55 2019-07-10
 */

 import {Component} from 'vue-property-decorator'
 import MnManageService from "./service/manageService"
 import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
 import override from "src/dectorators/override";
 import { MnManageDOI } from './api/mnmanageApi'
 
 @Component
 export default class Mnmanage extends BasicSearchPage<MnManageService, MnManageDOI.RowDataI, MnManageDOI.QueryRowDataParamsI> {
     @override
     renderHead(h) {
        return <div></div>
     }
     
     @override
     loadService () {
        this.service = new MnManageService(this)
     }
     
 }
 